/* eslint-disable no-undef */
/* eslint no-unused-vars: 0 */

/*
 |--------------------------------------------------------------------------
 | Bootstrap original javascript
 |--------------------------------------------------------------------------
 */
require('./_site')

/*
 |--------------------------------------------------------------------------
 | Initialize root component
 |
 | All components in ./components/autoload are registered by default.
 |--------------------------------------------------------------------------
 */
const app = new Vue({
    el: '#app'
})
